import { EFinancingCompany, ELanguage, ELoanPurpose } from '@if/core/types'
import LanguageIcon from '@mui/icons-material/Language'
import { IconButton, Link } from '@mui/material'
import { DataGrid, GridColDef, GridRenderCellParams } from '@mui/x-data-grid'
import { useSelectedCompany } from '@src/contexts/SelectedCompanyProvider'
import { Merchant } from '@src/data/types/Merchant'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  bannersList: Merchant[]
}

const BannersList = ({ bannersList }: Props) => {
  const { t } = useTranslation()
  const selectedCompany = useSelectedCompany()

  const columns = useMemo<GridColDef[]>(
    () => [
      {
        field: 'name',
        headerName: t('common.name'),
        flex: 2,
        renderCell: (params: GridRenderCellParams<Merchant, string>) => {
          return (
            <Link href={`/banner/${params.row.id}/view?financingCompanyId=IFinance`} variant="inherit">
              {params.value}
            </Link>
          )
        },
      },
      {
        field: 'email',
        headerName: t('common.email'),
        flex: 2,
      },
      {
        field: 'serviceCategory',
        headerName: t('common.serviceCategory'),
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (value: ELoanPurpose) => {
          return t(`ELoanPurpose.${value}`, { ns: 'enum' })
        },
      },
      {
        field: 'phone',
        headerName: t('common.phone'),
        flex: 1,
        align: 'center',
        headerAlign: 'center',
      },
      {
        field: 'languageId',
        headerName: t('common.language'),
        flex: 1,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (value: ELanguage) => {
          return t(`ELanguage.${value}`, { ns: 'enum' })
        },
      },
      {
        field: 'province',
        headerName: 'Province',
        headerAlign: 'center',
        align: 'center',
      },
      {
        field: 'website',
        headerName: t('common.website'),
        align: 'center',
        headerAlign: 'center',
        renderCell: (params: GridRenderCellParams<Merchant, string>) => {
          return (
            <IconButton disabled={!params.value}>
              <Link href={params.value} target="_blank">
                <LanguageIcon color={!params.value ? 'disabled' : 'inherit'} />
              </Link>
            </IconButton>
          )
        },
      },
    ],
    [t],
  )

  return (
    <div>
      <DataGrid
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 25,
            },
          },
        }}
        columnVisibilityModel={{
          serviceCategory: selectedCompany !== EFinancingCompany.Iceberg,
        }}
        pageSizeOptions={[25, 50, 100]}
        disableColumnFilter
        paginationMode="server"
        rowCount={bannersList.length}
        disableRowSelectionOnClick
        rows={bannersList}
        columns={columns}
      />
    </div>
  )
}

export default BannersList
